<template>
	<div class="area-choose">
		<el-select v-model="searchData.provinceCode" size="small" class="area-select"
			@change="e => provinceChangeHandle(e, '_search')">
			<el-option v-for="item in provinceList" :key="item.code"
				:label="item.name" :value="item.code">
			</el-option>
		</el-select>
		<el-select v-model="searchData.cityCode" size="small" class="area-select"
			@change="e => cityChangeHandle(e, '_search')">
			<el-option v-for="item in cityList" :key="item.code"
				:label="item.name" :value="item.code">
			</el-option>
		</el-select>
		<el-select v-model="searchData.areaCode" size="small" class="area-select">
			<el-option v-for="item in areaList" :key="item.code"
				:label="item.name" :value="item.code">
			</el-option>
		</el-select>
	</div>
</template>
<script scoped>
import commonReq from '@/api/common'
export default {
	data() {
		return {
			searchData: {
				provinceCode: '',
				cityCode: '',
				areaCode: ''
			},
			provinceList: [], //省份列表
			cityList: [], //城市列表
			areaList: [], //城市列表
		}
	},
	props: {
		isHasAll: {
			type: Boolean,
			default: () => true
		},
		rename: {
			type: Object,
			default: () => {}
		},
	},
	mounted() {
		this.getProvinceList()
	},
	methods: {
		setArea(area){
			if(!area) return
			if(!(area instanceof Object)) return
			const { provinceCode, cityCode, areaCode } = area
			this.searchData.provinceCode = provinceCode || ''
			this.searchData.cityCode = cityCode || ''
			this.searchData.areaCode = areaCode || ''
			provinceCode && this.provinceChangeHandle(provinceCode, false).then(()=>{
				cityCode && this.cityChangeHandle(cityCode, false)
			})
		},
		reset() {
			this.searchData.provinceCode = ''
			this.searchData.cityCode = ''
			this.searchData.areaCode = ''
		},
		getAreaData() {
			if(!this.rename || Object.keys(this.rename).length == 0){
				return this.searchData
			}
			const keyValues = {};
			for (const oldKey in this.searchData) {
				if (this.searchData.hasOwnProperty(oldKey)) {
					const newKey = this.rename[oldKey] || oldKey;
					keyValues[newKey] = this.searchData[oldKey];
				}
			}
			return keyValues
		},
        //获取省份列表
        getProvinceList() {
            commonReq.getProvince().then((res) => {
                if (res.Success) {
					if(this.isHasAll) {
                    	this.provinceList = [{code: '', name: '全部'}].concat(res.Data)
                    	this.cityList = [{code: '', name: '全部'}]
                    	this.areaList = [{code: '', name: '全部'}]
					} else {
                  		this.provinceList = res.Data
					}
                } else {
                    this.$message.error(res.Msg)
                }
            })
        },
        //省份选择框变值回调
        provinceChangeHandle(code, clearSelected = true) {
			return new Promise((resolve, reject)=>{
				if(clearSelected){
					this.searchData.cityCode = ''
					this.searchData.areaCode = ''
				}
				if(!code) {
            	    this.cityList = [{code: '', name: '全部'}]
            	    this.areaList = [{code: '', name: '全部'}]
					return
				}
            	this.cityList = []
            	this.areaList = []
            	commonReq.getCityOrArea(code).then((res) => {
            	    if (res.Success) {
            	        if(this.isHasAll) {
            	            this.cityList = [{code: '', name: '全部'}].concat(res.Data)
            	        } else {
            	            this.cityList = res.Data
            	        }
						resolve(res)
            	    } else {
            	        this.$message.error(res.Msg)
						reject(res)
            	    }
            	}).catch(err=>{
					return err
				})
			})
        },
        //城市选择框变值回调
        cityChangeHandle(code, clearSelected = true) {
           return new Promise((resolve,reject)=>{
				if(clearSelected){
					this.searchData.areaCode = ''
				}
            	this.areaList = []
				if(!code) {
            	    this.areaList = [{code: '', name: '全部'}]
					return
				}
            	commonReq.getCityOrArea(code).then((res) => {
            	    if (res.Success) {
            	        if(this.isHasAll) {
            	            this.areaList = [{code: '', name: '全部'}].concat(res.Data)
            	        } else {
            	            this.areaList = res.Data
            	        }
						resolve(res)
            	    } else {
            	        this.$message.error(res.Msg)
						reject(res)
            	    }
            	}).catch((err)=>{
					reject(err)
				})
		   })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/areaChoose.vue